import React from 'react';
import { useTranslation } from 'react-i18next';
import LegalLayout from '../components/layout/LegalLayout';
import './RefundsPage.css';

export default function RefundsPage() {
  const { t } = useTranslation();

  return (
    <LegalLayout
      title={t('legal.refunds.title')}
      description={t('legal.refunds.description')}
    >
      <div className="refundsPage">
        <h1 className="refundsPage__title">{t('legal.refunds.title')}</h1>
        <p className="refundsPage__lastUpdated">
          {t('legal.refunds.lastUpdated')}: {t('legal.refunds.effectiveDate')}
        </p>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.digitalProduct.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.digitalProduct.content')}</p>
        </section>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.subscriptionCancellation.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.subscriptionCancellation.intro')}</p>
          <p className="refundsPage__text">{t('legal.refunds.subscriptionCancellation.lemonSqueezy')}</p>
          <p className="refundsPage__text">{t('legal.refunds.subscriptionCancellation.process')}</p>
        </section>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.refundEligibility.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.refundEligibility.intro')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundEligibility.activeSubscriptions')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundEligibility.rightOfWithdrawal')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundEligibility.exceptions')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundEligibility.duplicatePayment')}</p>
        </section>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.refundProcess.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.refundProcess.intro')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundProcess.timing')}</p>
          <p className="refundsPage__text">{t('legal.refunds.refundProcess.method')}</p>
        </section>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.contact.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.contact.content')}</p>
          <p className="refundsPage__text">
            <a href="mailto:support@bodai.io" className="refundsPage__link">support@bodai.io</a>
          </p>
        </section>

        <section className="refundsPage__section">
          <h2 className="refundsPage__heading">{t('legal.refunds.lemonSqueezy.title')}</h2>
          <p className="refundsPage__text">{t('legal.refunds.lemonSqueezy.content')}</p>
        </section>
      </div>
    </LegalLayout>
  );
}

